import { getLMSToken } from "../components/utils.api";
import { LMS_TOKEN } from "./cookiesmanager";

export  const getLMSData = async () => {
    const lmsUserResponse = await getLMSToken();
  
    const {response:lmsData} = lmsUserResponse?.data || {};
  
    const {token:lmsToken} = lmsData || {};
  
    localStorage.setItem(LMS_TOKEN,lmsToken);
}